import { render, staticRenderFns } from "./UserAuthorizationDocumentsList.vue?vue&type=template&id=bc40a17c&"
import script from "./UserAuthorizationDocumentsList.vue?vue&type=script&lang=js&"
export * from "./UserAuthorizationDocumentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports